import moment from "moment";
import axios from "axios";
import Utils from "../../Utils";
import _ from "lodash";

const DiscussionItem = ({ data }) => {
  const fileUrl = data.filename ? `${process.env.REACT_APP_API_URL}/uploads/photoshoot_attachments/${data.filename}` : null;

  const downloadAttachment = (discussion) => {
    axios
      .get(Utils.apiUrl(`photoshoot/attachment/discussion/file/${discussion.id}`), {
        responseType: "arraybuffer", // Important for binary data
        ...Utils.apiHeaders(),
      })
      .then((res) => {
        console.log(res.data);

        // Convert buffer data into file
        const bufferData = res.data;

        // Convert to Uint8Array
        const byteArray = new Uint8Array(bufferData);

        // Create a Blob (set correct MIME type from response headers)
        const blob = new Blob([byteArray], {
          type: res.headers["content-type"] || "application/octet-stream",
        });

        // Get filename from headers or default
        const contentDisposition = res.headers["content-disposition"];
        //const filename = contentDisposition
        //    ? contentDisposition.split('filename=')[1]?.replace(/"/g, '') || `attachment_${attachment.id}`
        //    : `attachment_${attachment.id}`;

        const filename = discussion.filename;

        // Create download link
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();

        // Cleanup
        URL.revokeObjectURL(url);
        document.body.removeChild(a);
      })
      .catch((err) => {
        console.error("Download failed:", err);
        alert("Failed to download attachment");
      });
  };

  return (
    <div className="bg-white p-3 rounded border flex gap-3">
      {/* Circle Avatar */}
      <div className="w-6 h-6 rounded-full bg-blue-600 text-white flex items-center justify-center text-xs font-bold shrink-0">
        {data.usertype.toUpperCase()}
      </div>

      {/* Content */}
      <div className="flex-1">
        <div className="text-sm text-gray-800">{data.comment}</div>

        {fileUrl && (
          <button onClick={() => downloadAttachment(data)} className="text-blue-600 text-sm flex items-center gap-1 mt-1">
            <i className="fas fa-paperclip"></i>
            {data.filename}
          </button>
        )}

        <div className="text-xs text-gray-400 mt-1">{moment(data.created_at).fromNow()}</div>
      </div>
    </div>
  );
};

export default DiscussionItem;
